module.exports = __webpack_public_path__ + "static/media/Roboto-Condensed.cbd4e701.ttf";